module.exports = __webpack_public_path__ + "static/images/ce69127bedc0d932ad1172917f18d282.svg";